import { render, staticRenderFns } from "./ListSubcriberContentInfo.vue?vue&type=template&id=70b51da0&scoped=true"
import script from "./ListSubcriberContentInfo.vue?vue&type=script&lang=js"
export * from "./ListSubcriberContentInfo.vue?vue&type=script&lang=js"
import style0 from "./ListSubcriberContentInfo.vue?vue&type=style&index=0&id=70b51da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b51da0",
  null
  
)

export default component.exports